module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/approval/approval-grid/approval-grid.component.css
// module id = ./src/app/landprocurement/approval/approval-grid/approval-grid.component.css
// module chunks = main